export default __webpack_public_path__ + "static/media/white_play.6cc38ce3.svg";